import { type AxiosRequestConfig } from 'axios'

const deleteUserEducation = (id: string): AxiosRequestConfig => {
  return {
    method: 'DELETE',
    url: '/user/info/education/item',
    params: {
      id
    }
  }
}

export { deleteUserEducation }
